<div class="modal-overlay" (click)="close()">
  <div
    class="modal-container"
    (click)="$event.stopPropagation()"
    [ngClass]="{ large: step !== 'choose_type' }"
  >
    <!-- STEP 1: CHOOSE TYPE -->
    <ng-container *ngIf="step === 'choose_type'">
      <div class="modal-header">
        <div class="header-titles">
          <h2>Create Assessment</h2>
          <p>Choose how you want to add an assessment</p>
        </div>
        <button class="close-btn" (click)="close()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div class="modal-body type-selection-body">
        <div class="type-card" (click)="goToStep('create_new')">
          <div class="type-icon dark">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
              />
              <polyline points="14 2 14 8 20 8" />
              <line x1="12" y1="18" x2="12" y2="12" />
              <line x1="9" y1="15" x2="15" y2="15" />
            </svg>
          </div>
          <h3>Create New Assessment</h3>
          <p>
            Build a brand new quiz from scratch with full proctoring controls.
          </p>
          <span class="continue-link">Continue &rarr;</span>
        </div>
        <div class="type-card" (click)="goToStep('choose_existing')">
          <div class="type-icon purple">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
              <path
                d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
              />
            </svg>
          </div>
          <h3>Choose Existing Assessment</h3>
          <p>Reuse a published assessment and attach an active link.</p>
          <span class="continue-link">Continue &rarr;</span>
        </div>
      </div>
    </ng-container>

    <!-- STEP 2: CREATE NEW -->
    <ng-container *ngIf="step === 'create_new'">
      <div class="modal-header with-back">
        <button class="back-btn" (click)="close()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
        </button>
        <div class="header-titles">
          <h2>Add Assessment</h2>
          <p>
            Configure assessment details, audience and proctoring before adding
            questions
          </p>
        </div>
        <button class="close-btn" (click)="close()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div class="modal-body scrollable">
        <!-- 1. Quiz Details -->
        <div class="form-section">
          <div class="section-heading">
            <div class="step-num">1</div>
            <h3>Assessment Details</h3>
          </div>
          <div class="form-group">
            <label>Assessment Title <span class="req">*</span></label>
            <input
              type="text"
              [(ngModel)]="newQuiz.title"
              placeholder="e.g. Placement KickStart Assessment"
            />
          </div>
          <div class="form-group">
            <div class="label-row">
              <label>Assessment Description</label>
              <span class="opt-text">Optional</span>
            </div>
            <textarea
              [(ngModel)]="newQuiz.description"
              placeholder="Briefly describe what this assessment covers..."
              rows="3"
            ></textarea>
          </div>
        </div>

        <!-- 2. Configuration -->
        <div class="form-section">
          <div class="section-heading">
            <div class="step-num">2</div>
            <h3>Configuration</h3>
            <p class="section-desc">
              Control how students experience the assessment
            </p>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Duration <span class="req">*</span></label>
              <div class="duration-inputs">
                <div class="dur-box">
                  <input
                    type="number"
                    [(ngModel)]="newQuiz.durationHours"
                    min="0"
                  /><span>HH</span>
                </div>
                :
                <div class="dur-box">
                  <input
                    type="number"
                    [(ngModel)]="newQuiz.durationMinutes"
                    min="0"
                    max="59"
                  /><span>MM</span>
                </div>
                :
                <div class="dur-box">
                  <input
                    type="number"
                    [(ngModel)]="newQuiz.durationSeconds"
                    min="0"
                    max="59"
                  /><span>SS</span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>Attempts Allowed <span class="req">*</span></label>
              <input type="number" [(ngModel)]="newQuiz.attempts" min="1" />
            </div>
            <div class="form-group">
              <label>Passing Score (%)</label>
              <input
                type="number"
                [(ngModel)]="newQuiz.passingScore"
                placeholder="e.g. 60"
                min="0"
                max="100"
              />
            </div>
            <div class="form-group">
              <label
                >No. of Questions per User <span class="req">*</span></label
              >
              <input
                type="number"
                [(ngModel)]="newQuiz.questionsPerUser"
                placeholder="e.g. 10"
              />
              <span class="hint-text">Served per attempt</span>
            </div>
          </div>

          <div class="toggle-row">
            <div class="toggle-info">
              <h4>Shuffle Questions</h4>
              <p>Randomize the order of questions for each attempt</p>
            </div>
            <label class="switch">
              <input type="checkbox" [(ngModel)]="newQuiz.shuffleQuestions" />
              <span class="slider round"></span>
            </label>
          </div>
          <div class="toggle-row">
            <div class="toggle-info">
              <h4>Shuffle Options</h4>
              <p>Randomize the order of answer options</p>
            </div>
            <label class="switch">
              <input type="checkbox" [(ngModel)]="newQuiz.shuffleOptions" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>

        <!-- 3. Proctoring -->
        <div class="form-section">
          <div class="section-heading">
            <div class="step-num">3</div>
            <h3>Proctoring</h3>
            <p class="section-desc">
              Enable monitoring to maintain assessment integrity
            </p>
          </div>
          <div class="toggle-row highlight">
            <div class="toggle-info">
              <h4>Enable Proctoring</h4>
              <p>Proctored — monitoring features are active</p>
            </div>
            <label class="switch">
              <input type="checkbox" [(ngModel)]="newQuiz.enableProctoring" />
              <span class="slider round"></span>
            </label>
          </div>

          <div class="proctoring-grid" *ngIf="newQuiz.enableProctoring">
            <label class="checkbox-label"
              ><input
                type="checkbox"
                [(ngModel)]="newQuiz.proctoringOpts.detectTabSwitch"
                disabled
              />
              <span>Detect Tab Switch</span></label
            >
            <label class="checkbox-label"
              ><input
                type="checkbox"
                [(ngModel)]="newQuiz.proctoringOpts.restrictNewTabs"
                disabled
              />
              <span>Restrict New Tabs</span></label
            >
            <label class="checkbox-label"
              ><input
                type="checkbox"
                [(ngModel)]="newQuiz.proctoringOpts.enableCamera"
                disabled
              />
              <span>Enable Camera</span></label
            >
            <label class="checkbox-label"
              ><input
                type="checkbox"
                [(ngModel)]="newQuiz.proctoringOpts.faceDetection"
                disabled
              />
              <span>Face Detection</span></label
            >
            <label class="checkbox-label"
              ><input
                type="checkbox"
                [(ngModel)]="newQuiz.proctoringOpts.multiplePerson"
                disabled
              />
              <span>Multiple Person Detection</span></label
            >
            <label class="checkbox-label"
              ><input
                type="checkbox"
                [(ngModel)]="newQuiz.proctoringOpts.noTalking"
                disabled
              />
              <span>No Talking Detection</span></label
            >
            <label class="checkbox-label"
              ><input
                type="checkbox"
                [(ngModel)]="newQuiz.proctoringOpts.eyeMovement"
                disabled
              />
              <span>Eye Movement Tracking</span></label
            >
          </div>
        </div>
      </div>
      <div class="modal-footer split">
        <button class="btn-cancel" (click)="close()">Cancel</button>
        <button
          class="btn-primary"
          (click)="continueToQuestions()"
          *hasPermission="PermissionForStudents.QUIZ_CREATE"
          [disabled]="!isQuizFormValid || isAdding"
        >
          Continue to Questions &rarr;
        </button>
      </div>
    </ng-container>

    <!-- STEP 3: CHOOSE EXISTING -->
    <ng-container *ngIf="step === 'choose_existing'">
      <div class="modal-header with-back">
        <button class="back-btn" (click)="goToStep('choose_type')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
        </button>
        <div class="header-titles">
          <h2>Choose Existing Assessment</h2>
          <p>Select a published assessment to attach</p>
        </div>
        <button class="close-btn" (click)="close()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div class="modal-body table-body">
        <div class="table-controls">
          <div class="search-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input type="text" placeholder="Search assessments..." />
          </div>
          <select class="status-select">
            <option>All Status</option>
            <option>Active</option>
            <option>Draft</option>
          </select>
        </div>
        <div class="table-container">
          <table>
            <thead>
              <tr>
                <th>Assessment</th>
                <th>Questions</th>
                <th>Duration</th>
                <th>Active Links</th>
                <th>Created</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of existingAssessments">
                <td class="name-cell">
                  {{ item.name }}
                  <span class="recent-badge" *ngIf="item.isRecent">Recent</span>
                </td>
                <td>{{ item.questions }}</td>
                <td>{{ item.duration }}</td>
                <td>{{ item.links }}</td>
                <td class="date-cell">{{ item.created }}</td>
                <td>
                  <span
                    class="status-badge"
                    [ngClass]="item.status.toLowerCase()"
                    >{{ item.status }}</span
                  >
                </td>
                <td>
                  <button class="btn-select" (click)="selectExisting(item)">
                    Select &rarr;
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer split">
        <button class="btn-cancel" (click)="close()">Cancel</button>
        <span class="footer-hint">Select an assessment to continue</span>
      </div>
    </ng-container>

    <!-- STEP 4: SELECT LINK -->
    <ng-container *ngIf="step === 'select_link'">
      <div class="modal-header with-back">
        <button class="back-btn" (click)="goToStep('choose_existing')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
        </button>
        <div class="header-titles">
          <h2>Select Existing Link</h2>
          <p>Pick one or more active links for this assessment</p>
        </div>
        <button class="close-btn" (click)="close()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div class="modal-body table-body">
        <div class="link-tabs-row">
          <div class="tabs">
            <button
              class="tab-btn"
              [class.active]="activeLinkTab === 'active'"
              (click)="activeLinkTab = 'active'"
            >
              Active Links
            </button>
            <button
              class="tab-btn"
              [class.active]="activeLinkTab === 'expired'"
              (click)="activeLinkTab = 'expired'"
            >
              Expired Links
            </button>
          </div>
          <button class="btn-primary" (click)="goToStep('generate_link')">
            + Generate New Link
          </button>
        </div>
        <div class="table-container">
          <table>
            <thead>
              <tr>
                <th width="40"></th>
                <th>Link Name</th>
                <th>Audience</th>
                <th>Invited</th>
                <th>Start</th>
                <th>Expiry</th>
                <th>Status</th>
                <th>Created By</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let link of existingLinks; let i = index"
                (click)="selectLink(i)"
                [class.selected]="selectedLinkIndex === i"
              >
                <td>
                  <div
                    class="radio-circle"
                    [class.checked]="selectedLinkIndex === i"
                  >
                    <div class="inner-dot"></div>
                  </div>
                </td>
                <td class="name-cell fw-600">{{ link.name }}</td>
                <td>{{ link.audience }}</td>
                <td>{{ link.invited }}</td>
                <td class="date-cell">{{ link.start }}</td>
                <td class="date-cell">{{ link.expiry }}</td>
                <td>
                  <span class="status-badge active">{{ link.status }}</span>
                </td>
                <td>{{ link.creator }}</td>
                <td class="actions-cell">
                  <button class="icon-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                      <path
                        d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                      />
                    </svg>
                  </button>
                  <button class="icon-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  </button>
                  <button class="icon-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                    </svg>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer split">
        <button class="btn-cancel" (click)="close()">Cancel</button>
        <button
          class="btn-primary"
          [disabled]="selectedLinkIndex === null"
          (click)="useSelectedLink()"
        >
          Use Selected Link
        </button>
      </div>
    </ng-container>

    <!-- STEP 5: GENERATE LINK -->
    <ng-container *ngIf="step === 'generate_link'">
      <div class="modal-header with-back">
        <button class="back-btn" (click)="goToStep('select_link')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
        </button>
        <div class="header-titles">
          <h2>Generate Assessment Link</h2>
          <p>
            A unique URL will be auto-generated for assessment dashboard
            testing.
          </p>
        </div>
        <button class="close-btn" (click)="close()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div class="modal-body scrollable">
        <!-- Link Details -->
        <div class="form-section">
          <div class="section-heading small-mb">
            <div class="icon-bubble">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                />
                <path
                  d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
                />
              </svg>
            </div>
            <h3>Link Details</h3>
          </div>
          <div class="form-group">
            <label>Link Name <span class="req">*</span></label>
            <input
              type="text"
              [(ngModel)]="newLink.name"
              placeholder="link name"
            />
            <span class="hint-text">Internal label to identify this link.</span>
          </div>
        </div>

        <!-- Audience -->
        <div class="form-section">
          <div class="section-heading small-mb">
            <div class="icon-bubble">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <h3>Audience</h3>
          </div>

          <div class="audience-options">
            <label
              class="audience-radio-card"
              [class.selected]="newLink.audienceType === 'specific'"
            >
              <input
                type="radio"
                name="audType"
                value="specific"
                [(ngModel)]="newLink.audienceType"
              />
              <div class="radio-content">
                <div class="radio-title">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="8.5" cy="7" r="4" />
                    <line x1="20" y1="8" x2="20" y2="14" />
                    <line x1="23" y1="11" x2="17" y2="11" />
                  </svg>
                  Invite Specific Candidates
                </div>
                <p>Restrict access to invited email addresses.</p>
              </div>
            </label>
            <!--<label class="audience-radio-card" [class.selected]="newLink.audienceType === 'grouped'">
              <input type="radio" name="audType" value="grouped" [(ngModel)]="newLink.audienceType">
              <div class="radio-content">
                <div class="radio-title">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                  Grouped Quiz
                </div>
                <p>Assign to selected user groups.</p>
              </div>
            </label>-->
          </div>

          <div
            class="bulk-email-section"
            *ngIf="newLink.audienceType === 'specific'"
          >
            <div class="form-group">
              <label
                >Bulk add candidate emails <span class="req">*</span></label
              >
              <textarea
                [(ngModel)]="newLink.emails"
                placeholder="e.g. alice@example.com, bob@example.com"
                rows="4"
              ></textarea>
              <span class="hint-text"
                >Separate by commas, spaces or new lines</span
              >
            </div>
            <div class="bulk-email-actions">
              <button class="btn-outline-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="12" y1="5" x2="12" y2="19" />
                  <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
                Add to Invite List
              </button>
              <span class="invite-count">0 candidates added</span>
            </div>
          </div>
        </div>

        <!-- Validity -->
        <div class="form-section">
          <div class="section-heading small-mb">
            <div class="icon-bubble">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>
            <h3>Validity (UTC)</h3>
          </div>
          <div class="form-grid three-col">
            <div class="form-group">
              <label>Start Date <span class="req">*</span></label>
              <input
                type="datetime-local"
                class="date-input"
                [(ngModel)]="newLink.startDate"
              />
              <span class="hint-text">Defaults to now</span>
            </div>
            <div class="form-group">
              <label>End Date <span class="req">*</span></label>
              <input
                type="datetime-local"
                class="date-input"
                [(ngModel)]="newLink.endDate"
              />
              <span class="hint-text">Used to compute expiry</span>
            </div>
            <div class="form-group">
              <label>Expiry in (hours)</label>
              <input type="text" [(ngModel)]="newLink.expiryHours" />
              <span class="hint-text"
                >Defaults to 24h when no end date is set.</span
              >
            </div>
          </div>
        </div>

        <!-- Rules -->
        <div class="form-section">
          <div class="section-heading small-mb">
            <div class="icon-bubble">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="8" y1="6" x2="21" y2="6" />
                <line x1="8" y1="12" x2="21" y2="12" />
                <line x1="8" y1="18" x2="21" y2="18" />
                <line x1="3" y1="6" x2="3.01" y2="6" />
                <line x1="3" y1="12" x2="3.01" y2="12" />
                <line x1="3" y1="18" x2="3.01" y2="18" />
              </svg>
            </div>
            <h3>Rules</h3>
          </div>
          <div class="toggle-row no-border">
            <div class="toggle-info">
              <h4>Use Default Settings</h4>
              <p>
                Inherit all settings from the assessment. Turn off to customize
                settings specifically for this link only.
              </p>
            </div>
            <label class="switch">
              <input type="checkbox" [(ngModel)]="newLink.useDefaultSettings" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="modal-footer split">
        <button class="btn-cancel" (click)="close()">Cancel</button>
        <button class="btn-primary" (click)="goToStep('select_link')">
          Generate Link
        </button>
      </div>
    </ng-container>
  </div>
</div>
